import {createFetch} from '@vueuse/core'
import {useUserStore} from "../store/user.js";
import {storeToRefs} from "pinia";
import {Notify} from 'quasar'
import {ErrorResponse} from "../models/error";
import * as Sentry from "@sentry/vue";
import wretch, {Wretch} from "wretch"
export const useFetch = createFetch({
    baseUrl: import.meta.env.VITE_API_URL,
    options: {
        async beforeFetch({options}) {
            const store = useUserStore()
            const {token} = storeToRefs(store)

            if (token.value) {
                options.headers = {
                    ...options.headers,
                    Authorization: `Bearer ${token.value}`,
                };
            }

            return {options}
        },
        async onFetchError(ctx) {
            const data = ctx?.data;
            const url: string | undefined = ctx.response?.url
            if (url && url.endsWith('api/')) {
                return ctx;
            }
            let message = "Ошибка сервера (Обратитесь к администрации)"
            if (data) {
                if (typeof data === "string") {
                    const errorBody: ErrorResponse = JSON.parse(data);
                    message = errorBody.message
                } else {
                    message = data.message
                }
            }
            const store = useUserStore()

            if (store.loggedIn && ctx?.response?.status === 401) {
                await store.logout()
            }

            Notify.create({
                type: "negative",
                message: message,
                position: "top-right",
                actions: [
                    {
                        noDismiss: false,
                        icon: "close",
                        color: "white"
                    }
                ]
            })
            Sentry.addBreadcrumb({
                category: 'fetch',
                level: 'error',
                message: `Ошибка запроса ${ctx.response?.url} ${ctx.response?.status} ${ctx.response?.statusText}`,
                data: ctx.data
            })
            Sentry.setContext('request', {
                headers: ctx.response?.headers,
                url: ctx.response?.url,
                status: ctx.response?.status,
                statusText: ctx.response?.statusText,
                data: ctx.data,
                error: ctx.error
            })
            Sentry.captureException(ctx.error)
            return {
                data: null,
                error: new Error(ctx.data),
                response: ctx.response
            }
        },
    },
    fetchOptions: {
        mode: 'cors'
    },
})
export const newCdnFetch: Wretch = wretch(import.meta.env.VITE_CDN_URL)
export const useCdnFetch = createFetch({
    baseUrl: import.meta.env.VITE_CDN_URL,
    options: {
        async onFetchError(ctx) {
            const data = ctx?.data;

            let message = "Ошибка получения фото (Обратитесь к администрации)"
            if (data) {
                if (typeof data === "string") {
                    const errorBody: ErrorResponse = JSON.parse(data);
                    message = errorBody.message
                } else {
                    message = data.message
                }
            }


            Notify.create({
                type: "negative",
                message: message,
                position: "top-right",
                actions: [
                    {
                        noDismiss: false,
                        icon: "close",
                        color: "white"
                    }
                ]
            })
            Sentry.addBreadcrumb({
                category: 'fetch',
                level: 'error',
                message: 'Ошибка запроса',
                data: ctx.data
            })
            Sentry.captureException(new Error(ctx.data))
            return {
                data: null,
                error: new Error(ctx.data),
                response: ctx.response
            }
        },
    },
    fetchOptions: {
        mode: 'cors'
    },
})